import React from "react";
import { Badge } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";
import {
  OrchestrationCriteria,
  getConditionType,
} from "../../shared/domain/orchestrationCriteria.entity";
import { getConditionValueString } from "../../shared/utils/criteria.helper";
import { messages } from "../experiment.messages";
import {
  useConditionTypeLabels,
  useDeviceTypeLabels,
  useDayOfWeekLabels,
  useSeasonTypeLabels,
  useHemisphereLabels,
} from "../../orchestrator.messages";

interface ConditionChipsProps {
  criteria: OrchestrationCriteria | undefined;
}

export const ConditionChips: React.FC<ConditionChipsProps> = ({ criteria }) => {
  const theme = useTheme();
  const conditionTypeLabels = useConditionTypeLabels();
  const deviceTypeLabels = useDeviceTypeLabels();
  const dayOfWeekLabels = useDayOfWeekLabels();
  const seasonTypeLabels = useSeasonTypeLabels();
  const hemisphereLabels = useHemisphereLabels();

  if (!criteria || !criteria.conditions || criteria.conditions.length === 0) {
    return null;
  }

  const maps = {
    conditionTypeLabels,
    deviceTypeLabels,
    dayOfWeekLabels,
    seasonTypeLabels,
    hemisphereLabels,
  };

  return (
    <div
      className="rounded p-3 mt-2 mb-2"
      style={{ backgroundColor: theme.greyBackground }}
      data-testid="condition-chips">
      <h6 className="text-uppercase small font-weight-bold text-muted mb-2">
        <FormattedMessage {...messages.common.conditions} />
      </h6>
      <div className="d-flex flex-wrap" style={{ gap: "0.5rem" }}>
        {criteria.conditions.map((condition, idx) => {
          const type = getConditionType(condition);
          if (!type) return null;
          return (
            <Badge key={idx} variant="light" className="border font-weight-normal py-1 px-2">
              <strong>{conditionTypeLabels[type]}</strong>{" "}
              {getConditionValueString(condition, maps)}
            </Badge>
          );
        })}
      </div>
    </div>
  );
};
